import { useTranslation } from "react-i18next";
import type { Locale } from "@nh/shared";
import { Button } from "@/shared/ui/core";
import type { CartSubtotal } from "../cart.pricing";
import { CartCheckoutButton } from "./CartCheckoutButton";
import { CartSummary } from "./CartSummary";

export interface CartFooterProps {
  subtotal: CartSubtotal;
  locale: Locale;
  onClear: () => void;
}

/**
 * El pie del panel: subtotal, finalizar compra y vaciar.
 *
 * Va FUERA del área que se desplaza (`shrink-0` en un contenedor flex de
 * columna). Con veinte líneas en el carrito, un subtotal que solo aparece
 * al final del desplazamiento es un subtotal que nadie ve — y el botón de
 * comprar, uno que hay que ir a buscar.
 *
 * "Vaciar" es discreto y va abajo del todo, no junto a "Finalizar
 * compra": son la acción más destructiva y la más deseada del panel, y
 * ponerlas del mismo tamaño una al lado de la otra es cómo se vacía un
 * carrito sin querer.
 */
export function CartFooter({ subtotal, locale, onClear }: CartFooterProps) {
  const { t } = useTranslation();

  return (
    <div className="shrink-0 border-t border-ds-border bg-white px-5 py-4">
      <CartSummary subtotal={subtotal} locale={locale} />

      <div className="mt-4 grid gap-3">
        <CartCheckoutButton disabled={subtotal.countedItems === 0} />

        <Button
          variant="ghost"
          size="sm"
          onClick={onClear}
          className="mx-auto border-0 text-ds-ink-3 hover:text-ds-terracotta"
        >
          {t("Vaciar carrito")}
        </Button>
      </div>
    </div>
  );
}
